angular.
module("digiexam.components").
directive("languagePicker", function languagePickerDirective(
	dxLanguageCookieSetter
) {
	"use strict";

	return {
		restrict: "E",
		templateUrl: "directives/languagepicker.html",
		controller: function controller($scope, dxLocalize) {
			$scope.languages = [
				{
					key: "en",
					title: "English",
				}, {
					key: "sv",
					title: "Svenska",
				}, {
					key: "fi",
					title: "Suomi",
				},
			];

			$scope.currentLanguage = dxLocalize.getLanguage();

			$scope.picklang = function picklang(lang) {
				$scope.currentLanguage = lang.key;
				dxLocalize.setLanguage(lang.key);
				dxLanguageCookieSetter(lang.key);
			};
		},
	};
});
